import { render, staticRenderFns } from "./Game1-8.vue?vue&type=template&id=0f781808&scoped=true&"
import script from "./Game1-8.vue?vue&type=script&lang=js&"
export * from "./Game1-8.vue?vue&type=script&lang=js&"
import style0 from "./Game1-8.vue?vue&type=style&index=0&id=0f781808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f781808",
  null
  
)

export default component.exports